import { Notice } from '@plato/ui-legacy/components/ui/notice';
import { useTranslation } from 'react-i18next';
import { Can } from '../../acl/can.tsx';

type Props = {
    releasedDate?: string;
    className?: string;
};

export function IsReleasedBadge({ releasedDate, className = '' }: Props) {
    const { t } = useTranslation();

    if (releasedDate) {
        return null;
    }

    return (
        <Can do="read" on="QuoteOrder" field="released_date">
            <Notice
                variant="warning"
                className={className}
                title={t('badge__not_released_title', { ns: 'quotes-orders-line-items' })}
                description={
                    <Can I="release" a="QuoteOrder">
                        {t('badge__not_released_body', { ns: 'quotes-orders-line-items' })}
                    </Can>
                }
            />
        </Can>
    );
}
